<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-car"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">{{'OFFER_CONFIG.COMMUNICATION' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section" *ngIf="product.configuration.configurationStep === motorConfigurationStep.BASIC">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.POLICY_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-select [(ngModel)]="continuation"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.CALCULATION_SUBJECT].itemList"
                                        [hasEmpty]="false"
                                        [errorStateMatcher]="matchers.continuation"
                                        [label]="'OFFER_CONFIG.TYPE_OF_POLICY' | translate">
                            </app-select>
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="continuation === calculationSubject.CONTINUATION">
                        <div class="col-4">
                            <app-input [label]="'OFFER_CONFIG.LAST_YEAR_POLICY_NR' | translate"
                                       [errorStateMatcher]="matchers.previousPolicyNumber"
                                       [(ngModel)]="product.configuration.continuation.policyNumber">
                            </app-input>

                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'INSURANCE_PERIOD' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-datepicker [ngModel]="product.configuration.insuranceStartDate"
                                            (ngModelChange)="insuranceStartDate = $event"
                                            [errorStateMatcher]="matchers.insuranceStartDate"
                                            [minToday]="true"
                                            [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
                            </app-datepicker>
                        </div>
                        <div class="col-4">
                            <app-datepicker [(ngModel)]="product.configuration.insuranceEndDate"
                                            [disabled]="true"
                                            [errorStateMatcher]="matchers.insuranceEndDate"
                                            [label]="'OFFER_CONFIG.INSURANCE_DATE_TO' | translate">
                            </app-datepicker>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'MOTOR_CONFIG.INSURED_DATA' | translate }}</h3>

                    <ng-container *ngFor="let driver of product.configuration.driverList; let index = index">
                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.INSURED_NAME_PESEL' | translate">
                                    {{ product.parties[driver.partyId].fullName }},
                                    {{ product.parties[driver.partyId].pesel }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-datepicker
                                        [maxToday]="true"
                                        [label]="'MOTOR_CONFIG.DRIVING_LICENSE_DATE' | translate"
                                        [(ngModel)]="product.configuration.driverList[index].licenseDate"
                                        [errorStateMatcher]="matchers.driverList[index].licenseDate"
                                        [disabled]="product.configuration.driverList[index].noLicense"
                                        [slim]="true">
                                </app-datepicker>
                            </div>
                        </div>
                        <div class="row form-row">
                            <div class="col-4 form-label-static">
                                <mat-checkbox [ngModel]="product.configuration.driverList[index].noLicense"
                                              (ngModelChange)="setNoLicense(index, $event)">
                                    {{ 'MOTOR_CONFIG.NO_DRIVING_LICENSE' | translate }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </ng-container>

                    <app-errors [errorStateMatcher]="matchers.driverListGlobal"></app-errors>

                    <div class="separator"></div>

                    <app-eurotax-form [title]="'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate"
                                      [data]="product.configuration.vehicleDefinition"
                                      prefix="vehicleDefinition">
                    </app-eurotax-form>

                    <app-car-manual-form [data]="product.configuration.vehicleDefinition"
                                         *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.MANUAL"
                                         [title]="'MOTOR_CONFIG.MOTOR_DATA_MANUAL' | translate"
                                         prefix="vehicleDefinition">
                    </app-car-manual-form>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-numeric
                                    [label]="'MOTOR_CONFIG.MILEAGE' | translate"
                                    [(ngModel)]="product.configuration.vehicleDefinition.mileage"
                                    [errorStateMatcher]="matchers.vehicleDefinition.mileage"
                                    [suffix]="'LABEL.SUFFIX_KM' | translate">
                            </app-numeric>
                        </div>

                        <div class="col-4">
                            <app-datepicker
                                    [label]="'MOTOR_CONFIG.FIRST_REGISTRATION_DATE' | translate"
                                    [startingDate]="firstRegistrationDate"
                                    startingView="year"
                                    [(ngModel)]="product.configuration.vehicleDefinition.firstRegistrationDate"
                                    [maxToday]="true"
                                    [errorStateMatcher]="matchers.vehicleDefinition.firstRegistrationDate">
                            </app-datepicker>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-input
                                    [label]="'MOTOR_CONFIG.REGISTRATION_NUMBER' | translate"
                                    [(ngModel)]="product.configuration.vehicleDefinition.licensePlate"
                                    [errorStateMatcher]="matchers.vehicleDefinition.licensePlate">
                            </app-input>
                        </div>

                        <div class="col-4">
                            <app-input
                                    [label]="'MOTOR_CONFIG.VIN' | translate"
                                    [maxLength]="17"
                                    [(ngModel)]="product.configuration.vehicleDefinition.vin"
                                    [errorStateMatcher]="matchers.vehicleDefinition.vin">
                            </app-input>
                        </div>
                    </div>

                    <div class="row form-row"
                         *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.MANUAL">
                        <div class="col-4">
                            <app-numeric
                                    [label]="'MOTOR_CONFIG.MOTOR_VALUE' | translate"
                                    [(ngModel)]="product.configuration.vehicleDefinition.vehicleValue"
                                    [errorStateMatcher]="matchers.vehicleDefinition.vehicleValue"
                                    [suffix]="'LABEL.SUFFIX_PLN' | translate">
                            </app-numeric>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'MOTOR_CONFIG.VEHICLE_DETAILS' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-6 form-label-static">
                            <mat-checkbox [(ngModel)]="product.configuration.vehicleDefinition.steeringWheelRightSide">
                                {{ 'MOTOR_CONFIG.RIGHT_STEERING_WHEEL' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-select
                                    [label]="'MOTOR_CONFIG.UNUSUAL' | translate"
                                    [(ngModel)]="product.configuration.vehicleDefinition.vehicleUnusualUsage.usageList"
                                    [bindAsCode]="true"
                                    [multiple]="true"
                                    [itemList]="(dictionaries$|async)[dictionaryTypes.VEHICLE_UNUSUAL_USAGE].itemList"
                                    [errorStateMatcher]="matchers.vehicleDefinition.vehicleUnusualUsage">
                            </app-select>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'MOTOR_CONFIG.LEASING' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-6">
                            <mat-checkbox [ngModel]="product.configuration.leasing.selected"
                                          (ngModelChange)="leasing = $event">
                                {{ 'MOTOR_CONFIG.IS_IN_LEASING' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.leasing.selected">
                        <div class="col-6">
                            <app-input
                                    [label]="'MOTOR_CONFIG.LESSER_NAME' | translate"
                                    [errorStateMatcher]="matchers.leasing.name"
                                    [(ngModel)]="product.configuration.leasing.name">
                            </app-input>
                        </div>
                    </div>

                    <div *ngIf="product.configuration.leasing.selected">

                        <div class="separator"></div>

                        <h3 class="page-subheader">{{ 'MOTOR_CONFIG.LESSER_ADDRESS' | translate }}</h3>

                        <app-address-form [aside]="true"
                                          prefix="leasing.address"
                                          [address]="product.configuration.leasing.address">
                        </app-address-form>
                    </div>

                    <app-message-box *ngIf="matchers.calculation.errors.length > 0"
                                     [errorStateMatcher]="matchers.calculation"></app-message-box>

                </div>
            </div>

            <div class="section" *ngIf="product.configuration.configurationStep === motorConfigurationStep.CLAIMS">
                <div class="section-content">

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'MOTOR_CONFIG.CLAIMS_HISTORY' | translate}}</h3>

                    <ng-container *ngFor="let driver of product.configuration.driverList; let index = index">

                        <ng-container *ngIf="index > 0">
                            <hr>
                            <div class="separator"></div>
                        </ng-container>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.INSURED_NAME_PESEL' | translate">
                                    {{ product.parties[driver.partyId].fullName }},
                                    {{ product.parties[driver.partyId].pesel }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4"></div>
                            <div class="col-3">{{ 'LABEL.OC' | translate }}</div>
                            <div class="col-3">{{ 'LABEL.AC' | translate }}</div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.INSURANCE_COUNTINUITY' | translate}}
                            </div>
                            <div class="col-3">
                                <app-numeric
                                        [slim]="true"
                                        [disabled]="!product.configuration.missingClaimHistory"
                                        [(ngModel)]="driver.insuranceClaimHistory.thirdPartyLiability.continuityYears"
                                        [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.thirdPartyLiability.continuityYears">
                                </app-numeric>
                            </div>
                            <div class="col-3">
                                <app-numeric
                                        [slim]="true"
                                        [disabled]="!product.configuration.missingClaimHistory"
                                        [(ngModel)]="driver.insuranceClaimHistory.autocasco.continuityYears"
                                        [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.autocasco.continuityYears">
                                </app-numeric>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.CLAIMS_2YEARS' | translate}}
                            </div>
                            <div class="col-3">
                                <app-numeric
                                        [slim]="true"
                                        [disabled]="!product.configuration.missingClaimHistory"
                                        [(ngModel)]="driver.insuranceClaimHistory.thirdPartyLiability.claims2y"
                                        [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.thirdPartyLiability.claims2y">
                                </app-numeric>
                            </div>
                            <div class="col-3">
                                <app-numeric
                                        [slim]="true"
                                        [disabled]="!product.configuration.missingClaimHistory"
                                        [(ngModel)]="driver.insuranceClaimHistory.autocasco.claims2y"
                                        [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.autocasco.claims2y">
                                </app-numeric>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4 form-label-static-sm">
                                {{'MOTOR_CONFIG.CLAIMS_5YEARS' | translate}}
                            </div>
                            <div class="col-3">
                                <app-numeric [slim]="true"
                                             [disabled]="!product.configuration.missingClaimHistory"
                                             [(ngModel)]="driver.insuranceClaimHistory.thirdPartyLiability.claims5y"
                                             [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.thirdPartyLiability.claims5y">
                                </app-numeric>
                            </div>
                            <div class="col-3">
                                <app-numeric [slim]="true"
                                             [disabled]="!product.configuration.missingClaimHistory"
                                             [(ngModel)]="driver.insuranceClaimHistory.autocasco.claims5y"
                                             [errorStateMatcher]="matchers.driverList[index].insuranceClaimHistory.autocasco.claims5y">
                                </app-numeric>
                            </div>
                        </div>

                    </ng-container>

                    <app-message-box *ngIf="matchers.calculation.errors.length > 0"
                                     [errorStateMatcher]="matchers.calculation"></app-message-box>


                </div>

            </div>

            <div class="section" *ngIf="product.configuration.configurationStep === motorConfigurationStep.DETAILS">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'OFFER_CONFIG.INSURANCE_COVERAGE' | translate }}</h3>


                    <div class="row form-row" *ngIf="!product.configuration.autocasco.available">
                        <div class="col-12">
                            <app-alert alertType="info" class="w-100">
                                {{ 'MOTOR_CONFIG.AUTOCASCO_UNAVAILABLE' | translate }}
                            </app-alert>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-6"></div>
                        <div class="col-3">{{ 'MOTOR_CONFIG.SUM_OF_INSURANCE' | translate }}</div>
                        <div class="col-3 text-right">{{ 'OFFER_CONFIG.PREMIUM' | translate }}</div>
                    </div>

                    <div class="row form-row">
                        <div class="col-6 form-label-checkbox-sm">
                            <mat-checkbox [(ngModel)]="product.configuration.thirdPartyLiability.selected"
                                          [disabled]="true">
                                {{ 'MOTOR_CONFIG.INSURANCE_SCOPE_OC' | translate }}
                            </mat-checkbox>
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.ACCORDING_TO_LAW' | translate }}
                        </div>

                        <div class="col-3 text-right  form-label-checkbox-sm">
                            {{ product.configuration.thirdPartyLiability.premium | premium }}
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-6 form-label-checkbox-sm">
                            <mat-checkbox [disabled]="!product.configuration.autocasco.available"
                                          [(ngModel)]="product.configuration.autocasco.selected">
                                {{ 'MOTOR_CONFIG.INSURANCE_SCOPE_AC' | translate }}
                            </mat-checkbox>
                        </div>
                        <div class="col-3">
                            <app-numeric [(ngModel)]="product.configuration.autocasco.sumOfInsurance"
                                         [slim]="true"
                                         [disabled]="!product.configuration.autocasco.selected"
                                         [errorStateMatcher]="matchers.autocasco.sumOfInsurance"
                                         [suffix]="'LABEL.SUFFIX_PLN' | translate">
                            </app-numeric>
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            {{ product.configuration.autocasco.premium | premium }}
                        </div>
                    </div>

                    <div class="row form-row" *ngIf="product.configuration.autocasco.selected">
                        <div class="col-6 form-label-checkbox-sm">
                            {{ 'MOTOR_CONFIG.DAMAGE_LIQUIDATION' | translate }}
                        </div>
                        <div class="col-6">
                            <app-select [ngModel]="product.configuration.autocasco.claimSettlementMode?.code"
                                        (ngModelChange)="product.configuration.autocasco.claimSettlementMode = {code: $event}"
                                        [itemList]="(dictionaries$ | async)[dictionaryTypes.CLAIM_SETTLEMENT_MODE].itemList | onlyEstimate: product.configuration.operationYear > 25"
                                        [placeholder]="'LABEL.PICK' | translate"
                                        [slim]="true"
                                        [errorStateMatcher]="matchers.autocasco.claimSettlementMode">
                            </app-select>

                        </div>
                    </div>

                    <hr/>

                    <div class="row form-row">
                        <div class="col-6 form-label-checkbox-sm">
                            <mat-checkbox [(ngModel)]="product.configuration.accidentInsurance.selected">
                                {{ 'MOTOR_CONFIG.ADDON_NNW' | translate }}
                            </mat-checkbox>
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ product.configuration.accidentInsurance.sumOfInsurance | premium }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            <span>{{ product.configuration.accidentInsurance.premium | premium }}</span>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-6 form-label-checkbox-sm">
                            <mat-checkbox [(ngModel)]="product.configuration.motorAssistance.selected">
                                {{ 'MOTOR_CONFIG.ADDON_ASSSTANCE' | translate }}
                            </mat-checkbox>
                        </div>
                        <div class="col-3 form-label-checkbox-sm">
                            {{ product.configuration.motorAssistance.sumOfInsurance | premium }}
                        </div>

                        <div class="col-3 text-right form-label-checkbox-sm">
                            {{ product.configuration.motorAssistance.premium | premium }}
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="row">
                        <div class="col">
                            <h3 class="page-subheader">{{'OFFER_CONFIG.PAYMENTS' | translate}}</h3>
                        </div>
                        <div class="col-auto size-half-insurance h3 page-subheader">
                            <!--        Wysokość i termin płatności raty-->
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-auto size-property-col-1">
                            <app-select [ngModel]="product.configuration.paymentDefinition.installments?.code"
                                        [label]="'OFFER_CONFIG.INSTALLMENTS' | translate"
                                        [hasEmpty]="false"
                                        (ngModelChange)="product.configuration.paymentDefinition.installments = {code: $event}"
                                        [itemList]="(dictionaries$|async)[dictionaryTypes.INSTALLMENTS].itemList"
                                        [errorStateMatcher]="matchers.paymentDefinition.installments">
                            </app-select>
                        </div>

                        <div class="col-auto size-property-col-2">
                            <app-select
                                    [ngModel]="product.configuration.paymentDefinition.deferredPayment?.code"
                                    [label]="'OFFER_CONFIG.DEFERMENT' | translate"
                                    [hasEmpty]="false"
                                    (ngModelChange)="product.configuration.paymentDefinition.deferredPayment = {code: $event}"
                                    [itemList]="(dictionaries$|async)[dictionaryTypes.DEFERRED_PAYMENT].itemList"
                                    [errorStateMatcher]="matchers.paymentDefinition.deferredPayment">
                            </app-select>
                        </div>

                        <div class="col-auto size-half-insurance">
                            <div class="row" *ngIf="product.configuration.paymentDefinition.installmentList">
                                <div class="col-3"
                                     *ngFor="let element of product.configuration.paymentDefinition.installmentList">
                                    <!--                                            {{ 'OFFER_CONFIG.DATE_OF_PAYMENT' | translate }}-->
                                    <div class="inst">
                                        <div class="item-amount">{{ element.amount | premium }}</div>
                                        <div class="item-date">{{ element.date | lsnDate }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <app-message-box *ngIf="matchers.calculation.errors.length > 0"
                                     [errorStateMatcher]="matchers.calculation"></app-message-box>

                    <div class="separator"></div>

                    <hr/>

                    <div class="separator"></div>

                    <div class="row no-gutters" *ngIf="product.configuration.premium !== null">
                        <div class="col">
                            {{ 'OFFER_CONFIG.TOTAL_PREMIUM' | translate }}
                        </div>
                        <div class="col-auto">
                            <div class="text-price">
                                <div class="item-price">
                                    {{ product.configuration.premium | premium }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn-left">
            <button *ngIf="hasBackButton"
                    (click)="back()"
                    class="btn btn-secondary"
                    type="button">{{ 'BUTTON.BACK' | translate }}</button>
        </div>


        <div class="footer-btn">
            <button (click)="close()" class="btn btn-secondary"
                    type="button">{{ 'BUTTON.CANCEL' | translate }}</button>

            <button *ngIf="hasNextButton"
                    (click)="next()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.NEXT' | translate }}
            </button>

            <button
                    *ngIf="product.configuration.configurationStep === motorConfigurationStep.DETAILS && !productCalculated"
                    (click)="calculate()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.CALCULATE' | translate }}
            </button>

            <button
                    *ngIf="product.configuration.configurationStep === motorConfigurationStep.DETAILS && productCalculated"
                    (click)="save()"
                    class="btn btn-primary"
                    type="button">
                {{ 'BUTTON.SAVE' | translate }}
            </button>
        </div>
    </div>
</div>
